import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class DocumentCacheSource extends AbstractSource {
  constructor(getToken: () => string, public pdfCacheKey: string, private _withoutWatermark: boolean) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/document/temporary/pdf/" + this.pdfCacheKey + "?" + this.createParameterText();
    console.debug("[Source] " + url);
    return url;
  }

  /**
   * 受領書の印刷で透かしが出ないように対策している
   */
  private createParameterText(): string {
    const parameters = [
      "token=" + this.token,
      this._withoutWatermark ? "withCommitAction=true" : "",
    ];
    return parameters.filter(p => !!p).join("&");
  }

  public clone(): IContentSource {
    return new DocumentCacheSource(
      this._getToken,
      this.pdfCacheKey,
      this._withoutWatermark,
    );
  }
}
